module.exports = __webpack_public_path__ + "98293a5e37a2ece31c2d7d2f93d0c4fd.png";